import React from 'react'
import './style.css'

function EmptyTasks() {
  return (
    <div id="empty">
      <span>Nenhuma tarefa adicionada</span>
    </div>
  )
}

export default EmptyTasks